<div class="row">
  <div class="col" style="width: 50vw; height: 50vh;">
    <ng-lottie [options]="options" (loopComplete)="onLoopComplete()"></ng-lottie>
  </div>
</div>